import React from "react";
import { withStyles, Drawer } from "@material-ui/core";

import Menu from "@jll/menu";
import SearchBar from "../Filters/SearchBar";
import CheckTypeFilter from "../Filters/CheckTypeFilter";
import CountryFilter from "../Filters/CountryFilter";
import ScoreFilter from "../Filters/ScoreFilter";
import RecordTypeFilter from "../Filters/RecordTypeFilter";
import RequestAgeFilter from "../Filters/RequestAgeFilter";
import MyChecksFilter from "../Filters/MyChecksFilter";
import RiskLevelFilter from "../Filters/RiskLevelFilter";
import CheckStatusFilter from "../Filters/CheckStatusFilter";
import { styles } from "./styles";

const FilterSideBar = (props) => {
  const {
    classes,
    nameFilter,
    checkFilter,
    recordFilter,
    countryFilter,
    requestAgeFilter,
    myChecksFilter,
    scoreFilter,
    riskFilter,
    checkStatusFilter,
    defaultUserCountry,
    onSearchCriteriaChange,
    user,
  } = props;

  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
      anchor="left"
    >
      <Menu>
        {nameFilter && (
          <SearchBar onSearchCriteriaChange={onSearchCriteriaChange} />
        )}
        {checkFilter && (
          <CheckTypeFilter onSearchCriteriaChange={onSearchCriteriaChange} />
        )}
        {recordFilter && (
          <RecordTypeFilter onSearchCriteriaChange={onSearchCriteriaChange} />
        )}
        {countryFilter && (
          <CountryFilter
            defaultUserCountry={defaultUserCountry}
            user={user}
            onSearchCriteriaChange={onSearchCriteriaChange}
          />
        )}
        {scoreFilter && (
          <ScoreFilter onSearchCriteriaChange={onSearchCriteriaChange} />
        )}
        {requestAgeFilter && (
          <RequestAgeFilter onSearchCriteriaChange={onSearchCriteriaChange} />
        )}
        {myChecksFilter && (
          <MyChecksFilter onSearchCriteriaChange={onSearchCriteriaChange} />
        )}
        {riskFilter && <RiskLevelFilter />}
        {checkStatusFilter && (
          <CheckStatusFilter onSearchCriteriaChange={onSearchCriteriaChange} />
        )}
      </Menu>
    </Drawer>
  );
};

export default withStyles(styles, { withTheme: true })(FilterSideBar);
